import { motion } from 'framer-motion';

export default function InputField({ type, placeholder, value, onChange, delay = 0 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay, duration: 0.4 }}
      className="relative group"
    >
      <div className="rounded-xl border border-gray-200 transition-all duration-300 bg-white/95 group-hover:border-gray-300 group-focus-within:border-emerald-600 group-focus-within:ring-2 group-focus-within:ring-emerald-100">
        <input
          type={type}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          className="w-full px-4 py-3 text-sm font-medium bg-transparent rounded-[0.95rem] outline-none placeholder:text-gray-400 placeholder:font-normal focus:text-gray-900 focus:outline-none focus:ring-0"
        />
      </div>
    </motion.div>
  );
}


